module.exports = __webpack_public_path__ + "img/belgium-cardiovascular-diseases-male.208c97e9.png";